import type { IControl } from '@eureka/utils/control'

export interface AgentUploadLimitStrategy {
    getLimit(controlInfo?: IControl): number | undefined
}

export const AgentUploadLimitStrategy = Symbol('AgentUploadLimitStrategy')
